import axios from 'axios'
import VueApp from '../../main'
import { mainUrl } from '../../config/urls'
import { getDataFromLS } from '@/utils'

const state = {
  user: getDataFromLS('user', null),
  token: localStorage.getItem('token') || '',
  loading: false
}

const getters = {
  isAuthenticated: state => !!state.user,
  authLoading: state => state.loading
}

const actions = {
  AUTH_REQUEST: ({ commit }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')

      const formData = new FormData()
      formData.append('username', username)
      formData.append('password', password)

      axios
        .post(`${mainUrl}/api/login`, formData)
        .then(({ data }) => {
          const { token, user } = data

          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(user))
          axios.defaults.headers.common['token'] = token

          commit('AUTH_SUCCESS', { token, user })
          resolve(token)
        })
        .catch(error => {
          console.log('error --- ', error)
          localStorage.removeItem('token')
          reject(error)
        })
    })
  },
  AUTH_LOGOUT: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_LOGOUT')

      localStorage.removeItem('token')
      localStorage.removeItem('permissions')
      localStorage.removeItem('theme')

      delete axios.defaults.headers.common['token']

      VueApp.$socket.disconnect()
      VueApp.$socket.removeAllListeners()

      axios.delete('/saml/logout').then((res) => {
        if (res.data.redirect_to) {
          console.log('Redirect to', res.data.redirect_to)
          window.location.href = res.data.redirect_to
        }
        resolve()
      }).catch(error => {
        console.log('error --- ', error)
        localStorage.removeItem('token')
        reject(error)
      })
    })
  }
}

const mutations = {
  AUTH_REQUEST: state => {
    state.loading = true
  },
  AUTH_SUCCESS: (state, { token, user }) => {
    state.loading = false
    state.token = token
    state.user = user
  },
  AUTH_ERROR: state => {
    state.loading = false
  },
  AUTH_LOGOUT: state => {
    state.token = ''
    state.user = null
    state.loading = false
  },
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_USER_INFO: (state, payload) => {
    Object.keys(payload).forEach(f => (state.user[f] = payload[f]))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
